export const getDefaultValues = (subscribePackageDetails) => ({
  SubscribePackageTitle: subscribePackageDetails?.SubscribePackageTitle || '',
  SubscribePackageTitleSubtext: subscribePackageDetails?.SubscribePackageTitleSubtext || '',
  SubscribePackageDescription: subscribePackageDetails?.SubscribePackageDescription || '',
  SubscribePackageTermsAndCondition: subscribePackageDetails?.SubscribePackageTermsAndCondition || '',
  SubscribePackageImage: subscribePackageDetails?.SubscribePackageImage || '',
  SubscribePackageAmountDefault: subscribePackageDetails?.SubscribePackageAmountDefault || '',
  SubscribePackageAmountDiscount: subscribePackageDetails?.SubscribePackageAmountDiscount || '',
  SubscribePackageAmountFinal: subscribePackageDetails?.SubscribePackageAmountFinal || '',
  SubscribePackageSubscribePackagePositionID: subscribePackageDetails?.SubscribePackageSubscribePackagePositionID || '',
  SubscribePackageDaysCount: subscribePackageDetails?.SubscribePackageDaysCount || '',
  SubscribePackageOrderBy: subscribePackageDetails?.SubscribePackageOrderBy || '',
  SubscribePackageIsEnable: !!subscribePackageDetails?.SubscribePackageIsEnable,
  SubscribePackageIsSpecial: !!subscribePackageDetails?.SubscribePackageIsSpecial,
  SubscribePackageUserLevel: subscribePackageDetails?.SubscribePackageUserLevel,
  SubscribePackageClubPoint: subscribePackageDetails?.SubscribePackageClubPoint,
});
